import memoize from 'fast-memoize'
import { equals } from 'ramda'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const DEPLOY_ENV = process.env.ACTIVE_ENV || `development`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const doesBuildEqual = equals(DEPLOY_ENV)

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

export const isProductionBuild = () => doesBuildEqual(`production`)
export const isStagingBuild = () => doesBuildEqual(`staging`)
export const isTestBuild = () => doesBuildEqual(`test`)
export const isDevelopmentBuild = () => doesBuildEqual(`development`)

export const getEnvironment = memoize(() => {
  // Note that we need to use the full process.env instead of destructuring due
  // to Gatsby's use of Webpack's define plugin.
  const ORIGIN = {
    APP: process.env.API_ORIGIN_RAILS_APP,
    ONBOARDING_SERVICE: process.env.API_ORIGIN_ONBOARDING,
  }

  const HOST = {
    SELF: process.env.HOST_SELF,
    WWW: process.env.HOST_WWW,
    APP: process.env.HOST_RAILS_APP,
  }

  // eslint-disable-next-line prefer-destructuring
  const DOMAIN = process.env.DOMAIN

  const SERVICE = {
    RECAPTCHA: {
      KEY: process.env.RECAPTCHA_KEY,
    },
    GOOGLE_TAG_MANAGER: {
      ID: process.env.GOOGLE_TAG_MANAGER_ID,
      AUTH: process.env.GOOGLE_TAG_MANAGER_AUTH,
      PREVIEW: process.env.GOOGLE_TAG_MANAGER_PREVIEW,
    },
  }

  const CLIENT = {
    RECOMMENDATIONS_VERSION: process.env.RECOMMENDATIONS_VERSION,
  }

  return {
    ORIGIN,
    HOST,
    DOMAIN,
    SERVICE,
    CLIENT,
  }
})
